import { useDispatch } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TaskManagerScheduleButton from '../component/TaskManagerScheduleButton';
import TaskManagerClearScheduleButton from '../component/TaskManagerClearScheduleButton';
import TaskManagerClearStateButton from '../component/TaskManagerClearStateButton';
import TaskManagerPlayButton from '../component/TaskManagerPlayButton';
import TaskManagerTableService from '../service/TaskManagerTableService';
import TaskManagerResultButton from '../component/TaskManagerResultButton';
import AddTaskManagerButton from '../component/AddTaskManagerButton';
import TaskManagerFileListButton from '../component/TaskManagerFileListButton';
import TaskManagerNavigateButton from '../component/TaskManagerNavigateButton';
import TaskManagerLastMessageField from '../component/TaskManagerLastMessageField';
import TaskManagerLastResultField from '../component/TaskManagerLastResultField';
import TaskManagerStateField from '../component/TaskManagerStateField';
import TaskManagerEnabledButton from '../component/TaskManagerEnabledButton';
import DeleteErrorneousButton from '../component/DeleteErroneousButton';
import { useEffect } from 'react';
import { useNotifications } from 'app/admin/notification/NotificationProvider';

const config = {
	key: 'taskManagerTable',
	topic: 'taskManager',
	service: TaskManagerTableService,
	// editFormState: item => `/task-manager/edit/${item ? item.id : 'new'}`,
	editFormState: item => `/task-manager/edit/${item.type}/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh'/*, 'new'*/],
	rowAction: ['delete', 'modify'],
	rowButtonList: [{ key: 'play', component: TaskManagerPlayButton }, { key: 'updateScheduler', component: TaskManagerScheduleButton }, { key: 'clearScheduler', component: TaskManagerClearScheduleButton }, { key: 'clearState', component: TaskManagerClearStateButton }],
	// handleDelete: (sessionName, item) => TaskManagerTableService.deleteById(sessionName, item.id),
	toolbarButtonList: [
		{
			key: 'deleteErroneous',
			place: 'before',
			component: DeleteErrorneousButton
		},
		{
			key: 'addNew',
			place: 'before',
			component: AddTaskManagerButton
		},
	],
	filterFields: [
		{
			text: 'Name',
			propertyName: 'name',
			propertyType: 'String',
			type: 'LIKE',
			showInHeader: true
		},
		// {
		// 	text: 'Status',
		// 	propertyName: 'lastStatus',
		// 	propertyType: 'String',
		// 	type: 'EQ',
		// 	showInHeader: true
		// },
		{
			text: 'Type',
			propertyName: 'type',
			propertyType: 'String',
			type: 'EQ',
			showInHeader: true
		},
		{
			text: 'Scheduled',
			propertyName: 'schedule',
			propertyType: 'Boolean',
			type: 'IS_NULL',
			showInHeader: true
		}
	],
	columns: [
		{
			key: 'enabled',
			sortable: false,
			component: TaskManagerEnabledButton
		},
		{
			key: 'name'
		},
		{
			key: 'user.name'
		},
		{
			key: 'fileCount',
			sortable: false,
			component: TaskManagerFileListButton
		},
		{
			key: 'schedule',
			sortable: false
		},
		{
			key: 'type'
		},
		{
			key: 'okCount'
		},
		{
			key: 'failCount'
		},
		{
			key: 'lastStarted',
			type: 'dateTime'
		},
		{
			key: 'lastStatus'
		},
		{
			key: 'lastTimestamp',
			type: 'dateTime'
		},
		// {
		// 	key: 'state.last_date_time',
		// 	component: TaskManagerStateField
		// },
		{
			key: 'lastMessage',
			component: TaskManagerLastMessageField
		},
		{
			key: 'lastResult',
			component: TaskManagerLastResultField
		},
		{
			key: 'navigate',
			component: TaskManagerNavigateButton
		},
	]
};

function TaskManagerTable() {
	const { lastEvent } = useNotifications();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!lastEvent || !lastEvent.data) return;

		try {
			const msg = JSON.parse(lastEvent.data);
			if (msg && msg.name === 'mol.ocu.taskManager.taskStarted') {
				console.log('[TaskManager] taskStarted', msg.parameters);
				dispatch({ type: config.key + '/event/setNeedDataReload' });
			}
			if (msg && msg.name === 'mol.ocu.taskManager.taskFinished') {
				console.log('[TaskManager] taskFinished', msg.parameters);
				dispatch({ type: config.key + '/event/setNeedDataReload' });
			}
		} catch (e) {
		}
	}, [lastEvent]);

	return <TableBrowser config={config} />;
}
export default withReducer('taskManagerTable', reducer('taskManagerTable'))(TaskManagerTable);
